import { Rfc9457Error } from "@cede/utils";

function isObject(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}

export function extractHttpStatus(error: unknown): number | null {
  if (error instanceof Rfc9457Error) {
    return error.details.status;
  }

  if (!isObject(error)) {
    return null;
  }

  const details = error.details;
  if (isObject(details) && typeof details.status === "number") {
    return details.status;
  }

  if (typeof error.status === "number") {
    return error.status;
  }

  if (typeof error.statusCode === "number") {
    return error.statusCode;
  }

  return null;
}

export function extractErrorCode(error: unknown): string | null {
  if (!isObject(error)) {
    return null;
  }

  // API helper wraps the RFC 9457 response in error.details
  const details = error.details;
  if (isObject(details) && typeof details.type === "string") {
    return details.type;
  }

  if (typeof error.type === "string") {
    return error.type;
  }

  return null;
}

export function is4xxHttpError(error: unknown): boolean {
  const status = extractHttpStatus(error);
  return status !== null && status >= 400 && status < 500;
}
